<template>
  <div v-for="(leg, index) in flights.route" :key="index" class="item">
    <div class="line">
      <span>{{ leg.from.iata }}-{{ leg.to.iata }}</span>
      {{ getDateFlightfox(leg.depart) }}
    </div>
    <div class="line"><span>Cabin</span>{{ flights.cabin }}</div>
    <div class="line"><span>People</span>{{ flights.pax }}</div>
  </div>
</template>

<script setup>
import DateTime from "../utils/datetime.js";

defineProps(["flights"]);

const { getDateFlightfox } = DateTime();
</script>
